import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function AboutUs() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper style={{ padding: 20 }}>
          <Typography variant="h4" gutterBottom>About Us</Typography>
          <Typography variant="body1" paragraph>
            NEPTUNE TECHNOLOGY PTE. LTD. is an engineering firm with expertise in hardwire cable installations for voice, data, and fibre optic networks. We can handle any job, from single-drop wiring for small offices to the design, testing and deployment of complex networks for government, institutions and corporate enterprise.
          </Typography>
          <Typography variant="body1" paragraph>
            Founded in 2019 by NICOLAS ZHU ZHIJIA, NEPTUNE TECHNOLOGY PTE. LTD.  located at 3 Soon Lee Street, and is classified with the Small Business Administration (SBA) as a minority-veteran owned disadvantaged business. The Company has assembled a world-class team of industry professional and trained telecom engineers capable of delivering unparalleled expertise in a broad array of sophisticated environments. Their background and skill sets vary from Fibre Cable Installation, Termination, Testing, Commissioning, Breakdown Services, DATA Centre services, Cable Diversion Services, CAT5 and CAT6 Cable installations.
          </Typography>
          <Typography variant="body1" paragraph>
            The foremost endeavour of NEPTUNE TECHNOLOGY PTE. LTD. is to become a leading hardwire and wireless installation services contractor in the Singapore.
          </Typography>
          <Typography variant="h6" gutterBottom>Key to Success</Typography>
          <ul>
            <li>RESULTS: We deliver results by allying with leading telecom vendors and ISP, employing trained, licensed, and multi-skilled experts</li>
            <li>EXPERIENCE: Our seasoned team of technicians and engineers will help you drastically improve your telecommunication capabilities</li>
            <li>SAVE TIME: With one primary vendor, we manage your IT scope through an exhaustive tracking system.</li>
            <li>SAVE MONEY: We leverage our buying power, new technologies, vendors and knowledge to save your money.</li>
            <li>SUPPORT: We’re an extension of your team and we support you 24/7/365 through a dedicated expert.</li>
          </ul>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default AboutUs;